enum CalendarSettingsComparisonMethod {
    MEDIAN='MEDIAN', WEIGHTED_AVERAGE='WEIGHTED_AVERAGE'
}

export default CalendarSettingsComparisonMethod;
